import React from "react";
import {ISparkSwiperSlideController, SwipeDirectionEnum} from "./spark-swiper-slide-controller.interface";

import {computed, makeObservable} from "mobx";
import {ISparkSwiperController} from "./spark-swiper-controller.interface";



export abstract class SparkSwiperSlideController implements ISparkSwiperSlideController {
    constructor(private readonly id: string,
                protected readonly controller: ISparkSwiperController) {
        makeObservable(this);

    }

    abstract renderSlideContent(): React.ReactElement;
    abstract onBeforeDeactivate(swipeDirection: SwipeDirectionEnum): void;
    abstract onAfterActivated(swipeDirection: SwipeDirectionEnum): void;


    get key(): string {
        return `slide-ctrl-${this.id}`;
    }


    get isActiveSlide(): boolean {
        return this.itemIndexOffset === 0;
    }


    @computed
    get itemIndex(): number {
        const selfPosition = this.controller.findSlidePosition(this);
        const currentSlideIndex = this.controller.getCurrentItemIndex();
        let middleSlideControllerPosition = this.controller.middleSlidePosition;
        if(currentSlideIndex > this.controller.maxItemIndex - middleSlideControllerPosition) {
            // it means that we are closed to the end of the list and the middle slide controller is not actually in the middle and basically the middle slide controller moves at the beginning of the list
            middleSlideControllerPosition += middleSlideControllerPosition  - (this.controller.maxItemIndex - currentSlideIndex);
        }
        // when selfPosition > currentSlideIndex + (selfPosition - middleSlideControllerPosition)
        // it means that we are at the beginning of the slides list (currentSlideIndex is 0 or 1 assuming we have 2 slides before and 2 slides after the active one)
        return Math.max(selfPosition, currentSlideIndex + (selfPosition - middleSlideControllerPosition));
    }

    @computed
    get itemIndexOffset(): number {
        return this.itemIndex - this.controller.getCurrentItemIndex();
    }
}

